import "../styles/PageToolbarSearchFilter.css";

function SearchIcon() {
  return (
    <svg className="cmn-search-icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}

export default function PageToolbarSearch({
  value,
  onChange,
  placeholder = "Search...",
  inputRef,
  shortcutLabel = "⌘K",
}) {
  return (
    <div className="cmn-toolbar-search">
      <SearchIcon />
      <input
        ref={inputRef}
        className="cmn-search-input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
      />
      <span className="cmn-search-kbd">{shortcutLabel}</span>
    </div>
  );
}
